// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Button from '@atlaskit/button';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ExpandGroupButtonWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: "var(--ds-space-150, 12px)",
  marginBottom: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AvatarWrapper = styled.div({
  marginRight: "var(--ds-space-075, 6px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ExpandButton = styled(Button)({
  fontWeight: "var(--ds-font-weight-regular, 400)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& *': {
    pointerEvents: 'all',
    zIndex: 1
  }
});